// extracted by mini-css-extract-plugin
module.exports = {"semibold":"Map_semibold__wMGjC","map":"Map_map__Okd2x","mapWrapper":"Map_mapWrapper__xPYI2","mapPath":"Map_mapPath__acF61"};